import Phaser from "phaser";

export default class BackgroundScene extends Phaser.Scene {
  protected mBackground: Phaser.GameObjects.Image;
  private mName: string;
  private mPath: string;
  constructor(backgroundName: string, backgroundPath: string, name: string) {
    super(name);

    this.mName = backgroundName;
    this.mPath = backgroundPath;
  }
  preload() {
    this.load.image(this.mName, this.mPath);
  }

  create() {
    let width = this.cameras.main.width;
    let height = this.cameras.main.height;
    this.mBackground = this.add.image(width / 2, height / 2, this.mName);
    this.mBackground.setDisplaySize(width, height);
    this.mBackground.setDepth(-1);
  }
}
